import type { UseQueryResult } from '@tanstack/react-query';
import dayjs from 'dayjs';

import type { Duration } from '@/modules/api-routing';
import type { Trias } from '@/types/Trias';

export class TriasHelper {
  public static getIndividualRouteStructures(trias: Trias | undefined) {
    return trias?.serviceDelivery?.deliveryPayload?.individualRouteResponse?.routeResult;
  }

  public static getIndividualRouteStructure(trias: Trias | undefined, index: number) {
    return TriasHelper.getIndividualRouteStructures(trias)?.[index]?.route;
  }

  // public static getIndividualRouteStructureStrategies(routeResultStructure: RouteResultStructure) {
  //   return (
  //     routeResultStructure.route?.routeLeg
  //       ?.map((leg) => leg.legTrack?.trackSection?.[0]?.extension?.any?.value?.segmentReferences?.segmentReference)
  //       .flat()
  //       .filter(isNonNullable) ?? []
  //   );
  // }

  public static getErrors(trias: Trias | undefined) {
    const errors = trias?.serviceDelivery?.deliveryPayload?.individualRouteResponse?.errorMessage;

    return [...new Map(errors?.filter(({ code }) => code !== 'OK').map((item) => [item.text?.text, item])).values()];
  }

  public static getDuration(route: UseQueryResult<Trias> | undefined) {
    const duration = TriasHelper.getIndividualRouteStructure(route?.data, 0)?.duration;

    return duration && TriasHelper.formatDuration(duration);
  }

  public static formatDuration(duration: Duration) {
    const hours = Math.floor(dayjs.duration(duration).asHours());
    const minutes = Math.round(dayjs.duration(duration).asMinutes() % 60);

    let result = '';
    if (hours) result += `${hours} h`;
    if (minutes) result += ` ${minutes} min`;

    return result.trim();
  }

  public static formatDistance(distance: number | undefined) {
    if (!distance) return '';

    return distance < 1000 ? `${distance} m` : `${(distance / 1000).toFixed(1).replace('.', ',')} km`;
  }

  public static formatTimestamp(timestamp: string | undefined) {
    return timestamp ? dayjs(timestamp).format('HH:mm') : '';
  }
}
